<template>
  <Row>
    <!-- 树形目录 -->
    <Col span="6">
      <Tree :data="treeData" @on-select-change="clickData"></Tree>
    </Col>
    <!-- 部门列表 -->
    <Col span="18">
      <div class="public-screen">
        <span>{{ currentName }}</span>
        <Button
          type="primary"
          icon="md-add"
          v-access="'depaManagement.add'"
          @click="dpOpenFn()"
          >添加部门</Button
        >
      </div>
      <Table border stripe :loading="loading" :columns="columns" :data="tbList">
        <template slot-scope="{ row, index }" slot="index">
          <span v-if="false">{{ row }}</span>
          {{ (page - 1) * pageSize + index + 1 }}
        </template>
        <template slot="parent">
          {{ currentName }}
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            v-access="'depaManagement.status'"
            :value="row.status == 1"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            @click="dpOpenFn(row, index)"
            v-access="'depaManagement.edit'"
            >编辑</a
          >
          <a
            href="javascript:;"
            @click="removeFn(index, row)"
            v-access="'depaManagement.delete'"
            >删除</a
          >
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="pageSize"
        :current="page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
    <!-- 单个部门 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增部门' : '编辑部门'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form ref="formValidate" :label-width="80">
        <FormItem>
          <span slot="label" class="public-require">名称</span>
          <Input
            v-model="queryForm.depName"
            placeholder="请输入部门名称"
          ></Input>
        </FormItem>
        <FormItem>
          <span ref="brick" slot="label" class="public-require">所属部门</span>
          <Input v-if="editing" :value="currentName" disabled></Input>
          <Treeselect
            v-else
            v-model="queryForm.parentCode"
            :data="selectData"
            text-field-name="depName"
            value-field-name="code"
            size="small"
            placeholder="全部部门"
          ></Treeselect>
        </FormItem>
      </Form>
    </Modal>
  </Row>
</template>
<script>
import Treeselect from "vue-treeselect";
const columns = [
  {
    title: "序号",
    slot: "index",
  },
  {
    title: "部门名称",
    key: "depName",
  },
  {
    title: "所属部门",
    slot: "parent",
  },
  {
    title: "部门级别",
    key: "level",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      treeData: [],
      selectData: [],
      columns,
      tbList: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      currentName: "全部部门",
      currentCode: "",
      formModel: false,
      formTitle: "0",
      formModalLoading: true,
      queryForm: {
        depName: "",
        parentCode: "",
      },
      updateCode: "",
      editing: false,
    };
  },
  created() {
    this.getTree();
    this.getList();
  },
  watch: {
    // tree选择后收起选项
    "queryForm.parentCode"(a, b) {
      this.$refs.brick.click();
    },
    deep: true,
  },
  methods: {
    getTree() {
      this.$api["depAllSearch"]({}).then((res) => {
        if (res.code == "200") {
          let treeSt = {
            depName: "全部部门",
            code: "",
            expand: false,
            parentCode: "-1",
          };
          let selectSt = {
            depName: "全部部门",
            code: "",
            opened: false,
            parentCode: "-1",
          };
          let list = [];
          let list1 = [];
          if (res.data && res.data.length > 0) {
            list = [...res.data, treeSt];
            list1 = [...res.data, selectSt];
          }
          this.treeData = this.tools.arrayToTree(list, 0, "depName");
          this.selectData = this.tools.arrayToTree(list1, 1, "depName");
        }
      });
    },
    getList() {
      let data = {
        code: this.currentCode,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api["depSearch"](data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    clickData(arr, item) {
      this.currentName = item.depName;
      this.currentCode = item.code;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 删除部门
    removeFn(i, d) {
      let that = this;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.depName}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let data = { code: d.code };
          that.$api.depDelete(data).then((res) => {
            if (res.code == "200") {
              that.getTree();
              that.getList();
            }
          });
        },
      });
    },
    // 打开部门
    dpOpenFn(d) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      this.editing = d ? true : false;
      if (d) {
        this.updateCode = d.code;
        Object.keys(this.queryForm).forEach((key) => {
          this.queryForm[key] = d[key];
        });
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 确定部门
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      if (!this.queryForm.depName) {
        this.$Message.error("请输入部门名称");
        return;
      }
      let data = this.queryForm;
      let http = "depAdd";
      if (this.formTitle == 1) {
        data.code = this.updateCode;
        http = "depUpdate";
      }
      this.$api[http](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success("操作成功");
          this.cancelAction();
          this.getTree();
          this.getList();
        }
      });
    },
    cancelAction() {
      Object.keys(this.queryForm).forEach((key) => {
        this.queryForm[key] = "";
      });
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 状态
    stateChange(v, d, i) {
      let s = d.status == 1 ? "2" : "1";
      let data = {
        code: d.code,
        status: s,
      };
      this.$api["depStatus"](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/basic/depaManagement.vue